import $ from 'jquery';
import 'jquery-trend';
import 'jquery-revealer';
import ShopifySurfacePickUp from '@pixelunion/shopify-surface-pick-up';
import ShopifyVariants from 'shopify-variants';

import SidebarDrawer from './SidebarDrawer';
import AddToCartButton from './AddToCartButton';
import CartMini from './CartMini';
import RTE from './RTE';
import ShareThis from './ShareThis';
import ProductGallery from './ProductGallery';
import PaymentTerms from '../helpers/PaymentTerms';

export default class Product {
  constructor(component) {
    this.el = component.el;
    this.$el = $(this.el);
    this.data = component.data;
    this.onScroll = this.onScroll.bind(this);
    this.setupProductDetails = this.setupProductDetails.bind(this);

    this.window = $(window);
    this.productArea = $('.product-area', this.el);
    this.thumbsCount = this.productArea.find('.thumb').length;

    this.productDetailsWrapper = this.productArea.find('.product-details-wrapper');
    this.productDetails = this.productArea.find('.product-details');
    this.$productToggleFullview = $('.product-toggle-fullview', this.el);
    this.variantFields = {
      unitPrice: this.el.querySelector('[data-unit-price]'),
      totalQuantity: this.el.querySelector('[data-total-quantity]'),
      unitPriceAmount: this.el.querySelector('[data-unit-price-amount]'),
      unitPriceMeasure: this.el.querySelector('[data-unit-price-measure]'),
      taxLine: this.el.querySelector('[data-tax-line]'),
    };

    this.productGallery = new ProductGallery(
      this.el.querySelector('[data-product-gallery]'),
      {
        enable_video_autoplay: this.data.settings.gallery_enable_video_autoplay,
        enable_video_looping: this.data.settings.gallery_enable_video_looping,
      },
    );

    this.paymentTerms = new PaymentTerms(this.el);

    this.rteEls = this.el.querySelectorAll('.rte');
    this.rtes = [];

    for (let i = 0; i < this.rteEls.length; i++) {
      this.rtes.push(new RTE(this.rteEls[i]));
    }

    this.addToCartTrigger = this.el.querySelector('[data-product-submit]');
    this.addToCartButton = new AddToCartButton(this.addToCartTrigger);

    this.cartMini = new CartMini();

    this.selectedThumbIndex = 0;
    this.processing = false;

    this.eventId = `product-${this.el.id}`;

    if (this.data.settings.thumbOrientation === 'list') {
      this.setupProductDetails();
      this.window.on(`load.${this.eventId} resize.${this.eventId}`, this.setupProductDetails);
      this.window.on(`scroll.${this.eventId}`, this.setupProductDetails);
    }

    this.window.on(`shopify-variants:switch-variant.${this.eventId}`, (event, data) => this._onVariantSwitch(data.product, data.variant));
    this.setupVariants();
    if (window.Shopify && Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }

    $('.product-area .submit', this.el).on('click.product', e => {
      e.preventDefault();
      this.addToCart();
    });
    $('.product-area .single-option-selector', this.el).on('change.product', this.resetErrors.bind(this));

    this.shareThisEl = this.el.querySelector('[data-sharethis]');

    if (this.shareThisEl) {
      this.sharethis = new ShareThis(this.shareThisEl, this.productArea[0]);
    }
  }

  setupVariants() {
    if (!this.data.product) return;

    const $variants = $('[data-variants]', this.el);
    const $options = $('[data-product-option]', this.el);
    const $defaultVariant = $('input.product-select', this.el);

    if (!$variants.length && !$defaultVariant) return;

    this.surfacePickUp = new ShopifySurfacePickUp(this.el.querySelector('[data-surface-pick-up]'));

    if ($variants.length && $options.length) {
      this.variantHelpers = new ShopifyVariants(this.data.product, $variants, $options);
    }

    const selectedVariant = () => (this.variantHelpers
      ? this.variantHelpers.getSelectedVariant()
      : this.data.product.variants[0]); // product has only default variant

    if (!this.surfacePickUp.el) return;

    this.surfacePickUp.load(selectedVariant().id);
    this.surfacePickUp.onModalRequest(content => {
      const variantTitle = this.variantHelpers
        ? `<div class="sidebar-drawer__surface-pick-up-variant">${selectedVariant().title}</div>`
        : '';

      const header = `
          <h2 class="sidebar-drawer__surface-pick-up-title">${this.data.product.title}</h2>
          ${variantTitle}
        `;

      SidebarDrawer.open({ header, content });
    });
  }

  onScroll() {
    const viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

    if (
      (viewportWidth > 770)
      && (viewportHeight > this.detailsHeight)
    ) {
      this.positionProductInfo(this.stickyNavHeight, this.detailsHeight);
    } else {
      this.productDetails.css('position', 'static');
    }
  }

  setupProductDetails() {
    this.mainHeaderWrap = $('.main-header-wrap');

    this.productDetails.width(this.productDetailsWrapper.width());

    if (this.mainHeaderWrap.attr('data-header-layout') !== 'minimal') {
      this.stickyNavHeight = 0;
      this.detailsWrapperOffset = this.productDetailsWrapper.offset().top - this.stickyNavHeight;
      this.detailsHeight = this.productDetails.outerHeight(true) + this.stickyNavHeight;
    } else {
      this.stickyNavHeight = $('.header-minimal').outerHeight(true);
      this.detailsWrapperOffset = this.productDetailsWrapper.offset().top;
      this.detailsHeight = this.productDetails.outerHeight(true);
    }

    this.productDetailsWrapper.css({
      position: 'sticky',
      top: 0,
    });

    if (window.getComputedStyle(this.productDetailsWrapper[0]).position.indexOf('sticky') === -1) {
      this.onScroll();
    }
  }

  positionProductInfo(stickyNavHeight, detailsHeight) {
    const productImages = this.productArea.find('[data-product-gallery]');
    const scrollTop = this.window.scrollTop() + stickyNavHeight;
    const imagesBottom = productImages.offset().top + productImages.outerHeight(true);

    if (this.productDetails.outerHeight() >= productImages.outerHeight(true)) { return; }

    this.productDetails.css({
      position: 'fixed',
      top: (imagesBottom - detailsHeight) > scrollTop
        ? Math.max(0, productImages.offset().top - scrollTop)
        : (imagesBottom - detailsHeight) - scrollTop,
    });
  }

  handleErrors(response) {
    const error = JSON.parse(response.responseText);

    $('[data-product-form]', this.el).append(`<div class="error-message">${error.description}</div>`);

    this.timeout = setTimeout(() => {
      this.processing = false;
      this.addToCartButton.setState('error');
      setTimeout(() => this.addToCartButton.resetState(), 1000);
    }, 1000);
  }

  resetErrors() {
    $('.error-message', this.el).remove();
    this.processing = false;
  }

  addToCart() {
    if (this.processing) { return; }

    // Connect error handler
    // We need to do this each time because the quickshop might override it
    Shopify.onError = XMLHttpRequest => this.handleErrors(XMLHttpRequest);

    this.resetErrors();
    this.processing = true;
    this.addToCartButton.setState('loading');

    $.ajax({
      type: 'POST',
      url: `${window.Theme.routes.cart_add_url}.js`,
      data: $('[data-product-form]', this.el).serialize(),
      success: () => {
        if (this.data.settings.enable_cart_redirect) {
          window.location = window.Theme.routes.cart_url;
          return;
        }

        this.cartMini.refresh();
        this.timeout2 = setTimeout(() => {
          this.addToCartButton.setState('success');
          this.cartMini.open();

          this.timeout3 = setTimeout(() => {
            this.addToCartButton.resetState();
            this.processing = false;
          }, 1000);
        }, 1000);
      },
      error: this.handleErrors.bind(this),
      dataType: 'json',
    });
  }

  unload() {
    clearTimeout(this.timeout);
    clearTimeout(this.timeout2);
    clearTimeout(this.timeout3);
    this.rtes.forEach(rte => rte.unload());
    this.window.off(`.${this.eventId}`);
    $(document).off('click.product');
    $('.product-area .thumb', this.el).off('click.product');
    $('.product-area .submit', this.el).off('click.product');
    $('.modal-wrap .close', this.el).off('click.product');
    $('.product-area .single-option-selector', this.el).off('change.product');

    if (this.variantHelpers) {
      this.variantHelpers.unload();
    }

    if (this.shareThis) {
      this.sharethis.unload();
    }

    this.productGallery.unload();
  }

  _onVariantSwitch(product, variant) {
    if (product !== this.data.product) {
      return;
    }

    const { options } = variant;
    const $options = $('[data-product-option]', this.el);

    options.forEach((option, index) => {
      $options.eq(index).siblings('[data-selected-option]').text(option);
    });

    $('[data-product-variant-sku]', this.el).text(variant.sku || '');

    this.surfacePickUp.load(variant.id);
    this.paymentTerms.update(variant.id);
    this._updatePrice(variant);
    this._updateUnitPrice(variant);
    this._updateTaxLine(variant);
    this.productGallery.selectMediaByVariant(variant);
    this._updateHistory(variant);
  }

  _updateTaxLine(variant) {
    if (!this.variantFields.taxLine) return;

    if (variant.taxable) {
      this.variantFields.taxLine.classList.remove('hidden');
    } else {
      this.variantFields.taxLine.classList.add('hidden');
    }
  }

  _updateUnitPrice(variant) {
    if (this.variantFields.unitPrice && variant.unit_price_measurement) {
      this.variantFields.totalQuantity.innerHTML = `${variant.unit_price_measurement.quantity_value}${variant.unit_price_measurement.quantity_unit}`;

      this.variantFields.unitPriceAmount.innerHTML = Shopify.formatMoney(variant.unit_price, this.data.settings.money_format);
      if (variant.unit_price_measurement.reference_value === 1) {
        this.variantFields.unitPriceMeasure.innerHTML = variant.unit_price_measurement.reference_unit;
      } else {
        this.variantFields.unitPriceMeasure.innerHTML = `${variant.unit_price_measurement.reference_value}${variant.unit_price_measurement.reference_unit}`;
      }
      this.variantFields.unitPrice.classList.remove('hidden');
    } else if (this.variantFields.unitPrice) {
      this.variantFields.unitPrice.classList.add('hidden');
    }
  }

  _updatePrice(variant) {
    const $addToCartButton = $('[data-product-submit]', this.productArea);
    const $priceFields = $('.product__price', this.productArea);

    if (variant) {
      if (variant.available && !$('body').hasClass('template-password')) {
        $addToCartButton
          .val(this.data.locale.add_to_cart)
          .text(this.data.locale.add_to_cart)
          .removeClass('disabled')
          .removeAttr('disabled');
      } else {
        $addToCartButton
          .val(this.data.locale.sold_out)
          .text(this.data.locale.sold_out)
          .addClass('disabled')
          .attr('disabled', 'disabled');
      }

      if (variant.compare_at_price > variant.price) {
        $priceFields
          .find('.money:not(.original)')
          .html(window.Shopify.formatMoney(variant.price, this.data.settings.money_format));
        $priceFields
          .find('.money.original')
          .html(window.Shopify.formatMoney(variant.compare_at_price, this.data.settings.money_format))
          .removeClass('hidden');
      } else {
        $priceFields
          .find('.money:not(.original)')
          .html(window.Shopify.formatMoney(variant.price, this.data.settings.money_format));
        $priceFields
          .find('.money.original')
          .addClass('hidden');
      }
    } else {
      // Variant doesn't exist
      $addToCartButton
        .val(this.data.locale.unavailable)
        .addClass('disabled')
        .attr('disabled', 'disabled');
    }
  }

  _updateHistory(variant) {
    if (window.Shopify && window.Shopify.designMode) return;
    if (!this.data.settings.enable_history || (variant == null)) { return; }

    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }
}
